import { useQuery } from "react-query";

import { getGoalMasteryHistory } from "api/charts";
import { STALE_TIME_5_MINUTES, GET_GOAL_MASTERY_HISTORY } from "@constants/reactQueryKeys";

/**
 * Fetches a goal's weekly cumulative mastery history (the data behind the goal
 * mastery chart). Exposes `series` as the week-ordered cumulative count of
 * mastered targets. Disabled for invalid (falsy/NaN) goal ids.
 */
const useGetGoalMasteryHistory = (goalId: number) => {
  const {
    data: response,
    error,
    isLoading,
    ...rest
  } = useQuery(
    [GET_GOAL_MASTERY_HISTORY, goalId],
    () => getGoalMasteryHistory(goalId),
    {
      enabled: !!goalId,
      staleTime: STALE_TIME_5_MINUTES,
      refetchOnWindowFocus: false,
      retry: 2,
    }
  );

  return {
    series: response?.data?.series ?? [],
    errorMasteryHistory: error,
    isMasteryHistoryLoading: isLoading,
    ...rest,
  };
};

export default useGetGoalMasteryHistory;
